import { Input, message, Button, Dropdown, Tag as AntTag, Divider } from "antd";
import styles from "./index.module.scss";
import { Tag } from "@/components";
import { EllipsisText, Icon } from "@terminus/dqh-web-ui";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import dayjs from "dayjs";
import { BusinessCompanyInfoType } from "@/types";
import { useCurrentPage } from "@/hooks";
import { useCurrent } from "@/providers";
import WxShare from "@/components/wx-share";
import PayModal from "@/components/payModal";
import { RecommendOnselfModal } from "@/components/recommendOnselfModal";
import { EllipsisTooltip } from "@/components/ellipsis-tooltip";
const { Search: AntSearch } = Input;

const industryOptions = [
  { label: "建筑业", value: "CONSTRUCTION" },
  { label: "制造业", value: "MANUFACTURING" },
  { label: "批发和零售业", value: "WHOLESALE_RETAIL" },
  { label: "能源、石油及化工业", value: "ENERGY_CHEMICAL" },
  { label: "信息技术、软件及互联网", value: "INFORMATION_TECHNOLOGY" },
  { label: "医疗卫生", value: "HEALTHCARE" },
  { label: "教育", value: "EDUCATION" },
  { label: "交通运输、仓储及物流", value: "TRANSPORTATION_LOGISTICS" },
  { label: "金融、银行及保险", value: "FINANCE" },
  { label: "房地产及物业", value: "REAL_ESTATE" },
  { label: "农林牧渔业", value: "AGRICULTURE" },
  { label: "公共管理、政府及事业单位", value: "PUBLIC_ADMINISTRATION" },
  { label: "科研、咨询及专业服务", value: "PROFESSIONAL_SERVICES" },
  { label: "住宿、餐饮及旅游", value: "HOSPITALITY_TOURISM" },
  { label: "文化、体育及娱乐", value: "CULTURE_SPORTS" },
  { label: "环保、生态及环境治理", value: "ENVIRONMENTAL_SERVICES" },
  { label: "其他", value: "OTHER" },
];

export const SimpleBusinessSearch = (props: {
  companyInfo?: BusinessCompanyInfoType;
  type: "business" | "portal";
  onOpenCompanyDetail?: () => void;
  isGroup?: boolean;
  handleSubscribe?: (item: any) => void;
  // companyId 和 memberId 都是用于获取企业信息，但是在后端视角companyId已经无效了
  // 所以，当 companyId 和 memberId 都存在时，以 memberId 为准
  // 当 companyId 和 memberId 都不存在时，以 groupId 为准
  value?: {
    companyId?: any;
    memberId?: any;
    groupId?: any;
  };
  showCompanyDetail?: boolean;
  showDetailDrop?: boolean;
}) => {
  const {
    companyInfo = {} as BusinessCompanyInfoType,
    type,
    onOpenCompanyDetail,
    isGroup,
    handleSubscribe,
    value,
    showDetailDrop,
    showCompanyDetail,
  } = props;
  const { role, isLogin, memberQuotaBase } = useCurrent();
  const [showPayModal, setShowPayModal] = useState(false);
  const [showRecommendOnselfModal, setShowRecommendOnselfModal] =
    useState(false);
  const [recommendOnselfMemberId, setRecommendOnselfMemberId] =
    useState<string>("");
  const isSupplier = role === "supplier";
  const [searchValue, setSearchValue] = useState<string>("");
  const [logoError, setLogoError] = useState<boolean>(false);
  const { currentPage } = useCurrentPage();
  const turnToPage = useCurrentPage((state) => state.turnToPage);
  const navigate = useNavigate();
  const location = useLocation();

  const scene = (() => {
    const { groupId, companyId, memberId, companyName } = companyInfo || {};
    const params = [];
    if (
      (!groupId || groupId === "null") &&
      (!companyId || companyId === "null") &&
      (!memberId || memberId === "null")
    ) {
      return `companyName=${companyName}`;
    }
    if (groupId && groupId !== "null") {
      params.push(`groupId=${groupId}`);
    }
    if (companyId && companyId !== "null") {
      params.push(`companyId=${companyId}`);
    }
    if (memberId && memberId !== "null") {
      params.push(`memberId=${memberId}`);
    }
    return params.length > 0 ? `${params.join("&")}` : "";
  })();

  const onSearch = (v: string) => {
    // if (!v) {
    //   message.warning(
    //     type === "business"
    //       ? "请输入商机、标题、内容"
    //       : "请输入商机、标题、内容"
    //   );
    //   return;
    // }
    navigate(
      location.pathname.startsWith("/company")
        ? `/company/search?${v ? "keyword=" + v : ""}&memberId=${
            companyInfo.memberId
          }&groupId=${
            companyInfo.domainType !== "TENANT" ? companyInfo.groupId : ""
          }&companyName=${companyInfo.companyName}`
        : `/go/search?keyword=${v}`,
    );
  };

  const onChange = (e: any) => {
    setSearchValue(e.target.value);
  };

  const onCompanySearch = () => {
    navigate(
      location.pathname.startsWith("/company")
        ? `/go/search?keyword=${searchValue}`
        : `/company/search?keyword=${searchValue}&memberId=${
            companyInfo.memberId
          }&groupId=${
            companyInfo.domainType !== "TENANT" ? companyInfo.groupId : ""
          }&companyName=${companyInfo.companyName}`,
    );
  };
  const formatValue = (value: any, flag: boolean) => {
    const { groupId, memberId, companyName } = value || {};
    const params = [];
    if (
      (!groupId || groupId === "null") &&
      (!memberId || memberId === "null")
    ) {
      return `?companyName=${companyName}`;
    }
    if (groupId && groupId !== "null" && flag) {
      params.push(`groupId=${groupId}`);
    }
    if (memberId && memberId !== "null") {
      params.push(`memberId=${memberId}`);
    }
    return params.length > 0 ? `?${params.join("&")}` : "";
  };
  const handleGoPortal = (flag = false) => {
    const params = formatValue(companyInfo, flag);
    navigate(`/company${params}`);
  };

  const dropdownRender = useCallback(() => {
    return (
      <div className={styles.companyDropdownContainer}>
        {companyInfo?.groupName && (
          <div className={styles.companyDropdownTitle}>
            <span className={styles.companyDropdownTitleText}>
              <EllipsisText text={companyInfo?.companyName} />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                  gap: 4,
                  marginTop: 3,
                }}
              >
                {companyInfo?.domainType !== "JTB" && (
                  <img
                    src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/daqiyeIcon.svg"
                    style={{ width: 38, height: 20, marginBottom: 6 }}
                  />
                )}
                {!!companyInfo?.operationTagNameList?.length && (
                  <>
                    {companyInfo?.operationTagNameList?.map((item: string) => (
                      <Tag
                        type="warning"
                        title={item}
                        style={{
                          backgroundColor: "rgba(255, 86, 0, 0.2)",
                          color: "rgb(255, 86, 0)",
                          borderColor: "transparent",
                        }}
                      />
                    ))}
                  </>
                )}
                {/* {!!realNameAuthed && (
                  <Tag type="info" title="已实名" icon="yishiming" />
                )} */}
              </div>
            </span>
            {/* <img
              className={styles.companyDropdownTitleImage}
              alt=""
              src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/company-background.png"
            /> */}
          </div>
        )}
        <div className={styles.companyDropdownContent}>
          {(companyInfo?.operationTagNameList?.length || 0) > 0 ||
            ((companyInfo?.autoTagNameList?.length || 0) > 0 && (
              <>
                <div className={styles.companyDropdownTags}>
                  {companyInfo?.operationTagNameList?.map((item: string) => (
                    <AntTag key={item} title={item}>
                      {item}
                    </AntTag>
                  ))}
                  {companyInfo?.autoTagNameList?.map((item: string) => (
                    <AntTag key={item} title={item}>
                      {item}
                    </AntTag>
                  ))}
                </div>
                <div className={styles.companyDropdownContentDivider} />
              </>
            ))}
          {companyInfo.domainType === "JTB" ? (
            <div className={styles.companyDropdownContentOther}>
              <div className={styles.companyDropdownContentJTBItem}>
                <span className={styles.companyDropdownContentJTBItemLabel}>
                  法定代表人
                </span>
                <span className={styles.companyDropdownContentJTBItemValue}>
                  {companyInfo?.legalPerson || "--"}
                </span>
              </div>
              <div className={styles.companyDropdownContentJTBItem}>
                <span className={styles.companyDropdownContentJTBItemLabel}>
                  成立时间
                </span>
                <span className={styles.companyDropdownContentJTBItemValue}>
                  {companyInfo?.establishDate
                    ? dayjs(companyInfo?.establishDate).format("YYYY-MM-DD")
                    : "--"}
                </span>
              </div>
              <div className={styles.companyDropdownContentJTBItem}>
                <span className={styles.companyDropdownContentJTBItemLabel}>
                  注册资本
                </span>
                <span className={styles.companyDropdownContentJTBItemValue}>
                  {companyInfo?.capital || "--"}
                </span>
              </div>
              <div className={styles.companyDropdownContentJTBItem}>
                <span className={styles.companyDropdownContentJTBItemLabel}>
                  经营范围
                </span>
                <span
                  className={
                    styles.companyDropdownContentJTBItemValue +
                    " " +
                    styles.textEllipsis2
                  }
                >
                  {companyInfo?.businessScope || "--"}
                </span>
              </div>
            </div>
          ) : (
            <>
              {!!companyInfo.statsView && (
                <div className={styles.companyDropdownContentInfo}>
                  <div className={styles.companyDropdownContentInfoItem}>
                    <span className={styles.companyDropdownContentInfoText}>
                      历史询价
                    </span>
                    <span
                      className={styles.companyDropdownContentInfoTextStrong}
                    >
                      {companyInfo?.buyofferCount || 0}
                    </span>
                    <span className={styles.companyDropdownContentInfoText}>
                      次
                    </span>
                  </div>
                  <div className={styles.companyDropdownContentInfoItem}>
                    <span className={styles.companyDropdownContentInfoText}>
                      历史竞价
                    </span>
                    <span
                      className={styles.companyDropdownContentInfoTextStrong}
                    >
                      {companyInfo?.auctionCount || 0}
                    </span>
                    <span className={styles.companyDropdownContentInfoText}>
                      次
                    </span>
                  </div>
                  <div className={styles.companyDropdownContentInfoItem}>
                    <span className={styles.companyDropdownContentInfoText}>
                      历史招标
                    </span>
                    <span
                      className={styles.companyDropdownContentInfoTextStrong}
                    >
                      {companyInfo?.biddingCount || 0}
                    </span>
                    <span className={styles.companyDropdownContentInfoText}>
                      次
                    </span>
                  </div>
                  <div className={styles.companyDropdownContentInfoItem}>
                    <span className={styles.companyDropdownContentInfoText}>
                      年采金额
                    </span>
                    <span
                      className={styles.companyDropdownContentInfoTextStrong}
                    >
                      {companyInfo?.caigouAmount || 0}
                    </span>
                    <span className={styles.companyDropdownContentInfoText}>
                      {companyInfo?.moneyUnit}
                    </span>
                  </div>
                </div>
              )}
            </>
          )}
          <div
            className={styles.companyDropdownContentFooter}
            style={{ padding: isSupplier ? "12px 0 0 0" : "0" }}
          >
            {(isSupplier || !isLogin) && (
              <Button
                type="primary"
                ghost
                size="small"
                style={{
                  height: "36px",
                  borderRadius: "4px",
                  width: "50%",
                }}
                onClick={() => {
                  if (!isLogin) {
                    window.location.href = `${
                      process.env.LOGIN_URL
                    }?gotoUrl=${encodeURIComponent(window.location.href)}`;
                    return;
                  }
                  handleSubscribe?.({
                    subscribe: companyInfo?.subscribe,
                    companyId: value?.companyId,
                    memberId: value?.memberId,
                  });
                }}
              >
                {companyInfo?.subscribe ? "取消订阅" : "订阅企业"}
              </Button>
            )}
            <Button
              type="primary"
              size="small"
              style={{
                height: "36px",
                borderRadius: "4px",
                width: companyInfo.domainType !== "JTB" ? "50%" : "100%",
              }}
              onClick={() => {
                handleGoPortal(false);
              }}
            >
              前往门户
            </Button>
          </div>
        </div>
      </div>
    );
  }, [companyInfo]);

  const { realNameAuthed, logo } = companyInfo || {};
  return (
    <>
      <div className={styles.simpleSearchWrapper}>
        <div className={styles.simpleSearchInner}>
          <div className={styles.simpleSearchLeft}>
            <img
              src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/logo.png"
              className={styles.simpleSearchLeftPng}
              style={{ cursor: "pointer" }}
              onClick={() => {
                // turnToPage(navigate);
                window.location.href = `${process.env.YCX_HOME}`;
              }}
            />
            <span className={styles.simpleSearchLine} />

            {logo && !logoError && (
              <img
                src={logo}
                className={styles.simpleSearchLeftLogo}
                onError={(e) => {
                  setLogoError(true);
                }}
              />
            )}

            <div className={styles.simpleSearchContent}>
              {type === "business" && (
                <div style={{ display: "flex", gap: 4 }}>
                  <Dropdown dropdownRender={dropdownRender} trigger={["hover"]}>
                    <div
                      className={styles.simpleSearchLeftCompanyName}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        maxWidth: 570,
                      }}
                      onClick={() => handleGoPortal(true)}
                    >
                      <div
                        style={{
                          flex: 1,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {companyInfo?.groupName ||
                          companyInfo?.companyName ||
                          "--"}
                      </div>
                      <Icon name="xiadown" color="#A5A5A5" size={14} />
                    </div>
                  </Dropdown>
                  <div
                    className={styles.simpleSearchIC}
                    style={{ height: 20, paddingTop: 6, marginRight: 8 }}
                  >
                    {(() => {
                      const businessFlag =
                        companyInfo?.groupType === "SERVICE_PROVIDER" &&
                        type === "business";
                      const portalFlag =
                        companyInfo?.groupType === "SERVICE_PROVIDER" &&
                        type === "portal" &&
                        companyInfo?.domainType === "GROUP";
                      const shouldShowGroupIcon =
                        ((type === "business" && companyInfo?.groupName) ||
                          (type === "portal" &&
                            companyInfo?.domainType === "GROUP" &&
                            companyInfo?.groupType === "ORDINARY")) &&
                        !businessFlag &&
                        !portalFlag;
                      return shouldShowGroupIcon ? (
                        <img
                          src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/groupIcon.svg"
                          style={{ width: 32, height: 20, marginBottom: 6 }}
                          alt="集团图标"
                        />
                      ) : null;
                    })()}
                    {/* {((type === "business" && !companyInfo?.groupName) ||
                      (type === "portal" &&
                        companyInfo?.domainType !== "GROUP" &&
                        companyInfo?.groupType !== "ORDINARY")) && (
                      <img
                        src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/daqiyeIcon.svg"
                        style={{ width: 38, height: 20, marginBottom: 6 }}
                      />
                    )} */}
                    {companyInfo?.operationTagNameList?.map((item: string) => {
                      if (item === "独家签约企业" || item === "签约企业") {
                        const isExclusive = item === "独家签约企业";
                        return (
                          <img
                            key={item}
                            src={
                              isExclusive
                                ? "https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/dujiaqysj.svg"
                                : "https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/qianyuesj.svg"
                            }
                            style={{
                              width: isExclusive ? 88 : 64,
                              height: 20,
                              marginBottom:6
                            }}
                            alt={item}
                          />
                        );
                      }

                      return (
                        <Tag
                          type="warning"
                          title={item}
                          style={{
                            backgroundColor: "rgba(255, 86, 0, 0.2)",
                            color: "rgb(255, 86, 0)",
                            borderColor: "transparent",
                          }}
                        />
                      );
                    })}
                  </div>
                  {(!companyInfo?.groupName || !isLogin) && (
                    <span
                      onClick={() => {
                        if (!isLogin) {
                          window.location.href = `${
                            process.env.LOGIN_URL
                          }?gotoUrl=${encodeURIComponent(
                            window.location.href,
                          )}`;
                          return;
                        }
                        handleSubscribe?.({
                          subscribe: companyInfo?.subscribe,
                          companyId: value?.companyId,
                          memberId: value?.memberId,
                        });
                      }}
                      style={{
                        fontSize: 12,
                        display: "flex",
                        alignItems: "center",
                        marginBottom: 8,
                        cursor: "pointer",
                      }}
                    >
                      <Icon
                        color="#777779"
                        name={
                          !companyInfo?.subscribe
                            ? "shangjikapian-dingyueqiye"
                            : "shangjikapian-yidingyue"
                        }
                        size={12}
                      />
                      {companyInfo?.subscribe ? "取消订阅" : "订阅企业"}
                    </span>
                  )}
                </div>
              )}
              {type === "portal" && (
                <div
                  className={styles.simpleSearchLeftCompanyName}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    maxWidth: "80%",
                  }}
                >
                  <EllipsisTooltip text={companyInfo?.companyName || "--"} />

                  <div
                    className={styles.simpleSearchIC}
                    style={{ height: 20, paddingTop: 6, marginRight: 8 }}
                  >
                    {(() => {
                      const businessFlag =
                        companyInfo?.groupType === "SERVICE_PROVIDER" &&
                        type === "business";
                      const portalFlag =
                        companyInfo?.groupType === "SERVICE_PROVIDER" &&
                        type === "portal" &&
                        companyInfo?.domainType === "GROUP";
                      const shouldShowGroupIcon =
                        ((type === "business" && companyInfo?.groupName) ||
                          (type === "portal" &&
                            companyInfo?.domainType === "GROUP" &&
                            companyInfo?.groupType === "ORDINARY")) &&
                        !businessFlag &&
                        !portalFlag;
                      return shouldShowGroupIcon ? (
                        <img
                          src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/groupIcon.svg"
                          style={{ width: 32, height: 20, marginBottom: 6 }}
                          alt="集团图标"
                        />
                      ) : null;
                    })()}
                    {/* {((type === "business" && !companyInfo?.groupName) ||
                      (type === "portal" &&
                        companyInfo?.domainType !== "GROUP" &&
                        companyInfo?.groupType !== "ORDINARY")) && (
                      <img
                        src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/daqiyeIcon.svg"
                        style={{ width: 38, height: 20, marginBottom: 6 }}
                      />
                    )} */}
                    {companyInfo?.operationTagNameList?.map((item: string) => {
                      if (item === "独家签约企业" || item === "签约企业") {
                        const isExclusive = item === "独家签约企业";
                        return (
                          <img
                            key={item}
                            src={
                              isExclusive
                                ? "https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/dujiaqysj.svg"
                                : "https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/qianyuesj.svg"
                            }
                            style={{
                              width: isExclusive ? 82 : 60,
                              height: 20,
                              marginBottom:6,
                            }}
                            alt={item}
                          />
                        );
                      }

                      return (
                        <Tag
                          type="warning"
                          title={item}
                          style={{
                            backgroundColor: "rgba(255, 86, 0, 0.2)",
                            color: "rgb(255, 86, 0)",
                            borderColor: "transparent",
                          }}
                        />
                      );
                    })}
                  </div>
                  {(!(
                    // 门户这边companyInfo?.domainType就是集团
                    (companyInfo?.domainType === "GROUP")
                  ) ||
                    !isLogin) && (
                    <>
                      <span
                        onClick={() => {
                          if (!isLogin) {
                            window.location.href = `${
                              process.env.LOGIN_URL
                            }?gotoUrl=${encodeURIComponent(
                              window.location.href,
                            )}`;
                            return;
                          }
                          handleSubscribe?.({
                            subscribe: companyInfo?.subscribe,
                            companyId: value?.companyId,
                            memberId: value?.memberId,
                          });
                        }}
                        style={{
                          fontSize: 12,
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          color: companyInfo?.subscribe
                            ? "rgb(165, 165, 165)"
                            : "#FF5600",
                          flexShrink: 0,
                        }}
                      >
                        <Icon
                          color="#777779"
                          name={
                            !companyInfo?.subscribe
                              ? "shangjikapian-dingyueqiye"
                              : "shangjikapian-yidingyue"
                          }
                          size={12}
                        />
                        {companyInfo?.subscribe ? "已订阅" : "订阅企业"}
                      </span>
                      {companyInfo?.isExclusive && (
                        <>
                          <Divider type="vertical" />
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                              fontSize: 12,
                              color: "#FF5600",
                              cursor: "pointer",
                              flexWrap:'nowrap'
                            }}
                            onClick={() => {
                              if (!memberQuotaBase) {
                                setShowPayModal(true);
                                return;
                              }
                              setShowRecommendOnselfModal(true);
                              setRecommendOnselfMemberId(companyInfo?.memberId);
                            }}
                          >
                            <img
                              src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/recommendSelf.png"
                              style={{ width: 12, height: 12 }}
                            />
                            供应商自荐
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              )}

              <div className={styles.simpleSearchIC}>
                {/* {!!realNameAuthed && !isGroup && (
                  <Tag
                    type="info"
                    title="已实名"
                    icon="yishiming"
                    style={{ marginBottom: 0 }}
                  />
                )} */}
                {/* {!!taxpayer && (
                  <Tag
                    icon="yibannashuiren"
                    type="info"
                    title="一般纳税人"
                    style={{}}
                  />
                )} */}
                {!!companyInfo?.provinceCity && companyInfo?.provinceCity !== "null" && (
                  <>
                    <div className={styles.simpleSearchICItem}>
                      <img src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/localDetailIcon.png" />
                      <EllipsisTooltip
                        text={companyInfo?.provinceCity || "--"}
                      />
                    </div>
                    {/* {(companyInfo?.industry || companyInfo?.annualProcurementAmountWan) && <div className={styles.simpleSearchICSplit} />} */}
                  </>
                )}
                {/* {!!companyInfo?.industry && companyInfo?.industry!=='OTHER'  && (
                  <>
                    <div className={styles.simpleSearchICItem}>
                      <img src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/factoryTypeIcon.png" />
                      <EllipsisTooltip
                        text={
                          industryOptions.find(
                            (option) => option.value === companyInfo?.industry,
                          )?.label || "--"
                        }
                      />
                    </div>
                    {companyInfo?.annualProcurementAmountWan && <div className={styles.simpleSearchICSplit} />}
                  </>
                )} */}
                {!!companyInfo?.annualProcurementAmountWan && (
                  <div className={styles.simpleSearchICItem}>
                    <img src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/moneyIconTop1.png" />
                    <EllipsisTooltip
                      text={`预估年采购规模 ${
                        companyInfo?.annualProcurementAmountWan || "-"
                      } 万元`}
                    />
                  </div>
                )}

                <WxShare
                  params={{
                    page: "pages/enterprisePortal/index",
                    scene: scene,
                    env_version: window.location.href.includes("daqihui.com")
                      ? "release"
                      : "trial",
                    check_path: false,
                    operationType: "shareCompany",
                  }}
                  label="分享企业"
                  style={{}}
                  shareText={"查看企业详情"}
                />

                {type === "portal" &&
                  showDetailDrop &&
                  (value?.companyId || value?.memberId || value?.groupId) && (
                    <>
                      <Divider type="vertical" />
                      <span
                        className={styles.simpleSearchExpand}
                        onClick={() => onOpenCompanyDetail?.()}
                      >
                        {showCompanyDetail ? "收起企业详情" : "展开企业详情"}
                        <Icon
                          name={showCompanyDetail ? "shangup" : "xiadown"}
                          color="#A5A5A5"
                          size={12}
                        />
                      </span>
                    </>
                  )}

                {/* <div className={styles.zmCredit}>
                      <img src={zmCredit} />
                      <div>{supplierInfo?.zmCreditLevel || '-'}</div>
                    </div> */}
              </div>
            </div>
          </div>
          <div className={styles.simpleSearchRight}>
            <AntSearch
              placeholder="搜索商机 标题、内容"
              allowClear
              enterButton={(() => {
                if (location.pathname.startsWith("/company")) {
                  return "企业内搜索";
                } else {
                  return currentPage === "business-opportunity"
                    ? "搜全站"
                    : "搜索";
                }
              })()}
              size="large"
              onSearch={onSearch}
              onChange={onChange}
            />
            <Button
              type="primary"
              onClick={onCompanySearch}
              ghost
              size="middle"
              style={{ height: "36px", marginLeft: "12px", borderRadius: "4px" }}
            >
              {location.pathname.startsWith("/company") ? "搜全站" : "企业内搜索"}
            </Button>
          </div>
        </div>
      </div>
      <PayModal
        open={showPayModal}
        onCancel={() => setShowPayModal(false)}
        onOk={() => setShowPayModal(false)}
      />
      <RecommendOnselfModal
        visible={showRecommendOnselfModal}
        setVisible={setShowRecommendOnselfModal}
        memberId={recommendOnselfMemberId}
      />
    </>
  );
};
